<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CS963-skriver">
     CS963-skriver
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_no" title="Sikkerhetsinformasjon">
     Sikkerhetsinformasjon
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvensjoner">
      Konvensjoner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Produkterkl&aelig;ringer">
      Produkterkl&aelig;ringer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_no" title="Bli kjent med skriveren">
     Bli kjent med skriveren
    </a>
   </p>
   <div id="divd0e213">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_no" title="Finne informasjon om skriveren">
      Finne informasjon om skriveren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_no" title="Finne skriverens serienummer">
      Finne skriverens serienummer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_no" title="Skriverkonfigurasjoner">
      Skriverkonfigurasjoner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_no" title="Ved hjelp av kontrollpanelet">
      Ved hjelp av kontrollpanelet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_no" title="Ikoner p&aring; startsiden">
      Ikoner p&aring; startsiden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_no" title="Farger p&aring; indikatorlampen">
      Farger p&aring; indikatorlampen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_no" title="Finne sikkerhetssporet">
      Finne sikkerhetssporet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e715" title="Velge papir">
      Velge papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10510" title="Ytterligere skriverfunksjoner og st&oslash;tte">
      Ytterligere skriverfunksjoner og st&oslash;tte
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_no" title="Installere og konfigurere">
     Installere og konfigurere
    </a>
   </p>
   <div id="divd0e10628">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_no" title="Velge en plassering for skriveren">
      Velge en plassering for skriveren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_no" title="Skriverporter">
      Skriverporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#d0e10808" title="Konfigurere programmer og l&oslash;sninger">
      Konfigurere programmer og l&oslash;sninger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e10966" title="Konfigurering og bruk av tilgjengelighetsfunksjonene">
      Konfigurering og bruk av tilgjengelighetsfunksjonene
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_no" title="Legge i papir og spesialpapir">
      Legge i papir og spesialpapir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11672" title="Installere og oppdatere programvare, drivere og fastvare">
      Installere og oppdatere programvare, drivere og fastvare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e11975" title="Installere tilleggsmaskinvare">
      Installere tilleggsmaskinvare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13455" title="Nettverksutskrift">
      Nettverksutskrift
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_no" title="Sikre skriveren">
     Sikre skriveren
    </a>
   </p>
   <div id="divd0e13806">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_no" title="Slette skriverminne">
      Slette skriverminne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_no" title="Slette skriverlagringsstasjonen">
      Slette skriverlagringsstasjonen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_no" title="Gjenopprette fabrikkinnstillingene">
      Gjenopprette fabrikkinnstillingene
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_no" title="Erkl&aelig;ring om flyktig og ikke-flyktig minne">
      Erkl&aelig;ring om flyktig og ikke-flyktig minne
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_no" title="Skriv ut">
     Skriv ut
    </a>
   </p>
   <div id="divd0e13996">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_no" title="Skrive ut fra en datamaskin">
      Skrive ut fra en datamaskin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14047" title="Skrive ut fra en mobilenhet">
      Skrive ut fra en mobilenhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_no" title="Skrive ut fra flash-enhet">
      Skrive ut fra flash-enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_no" title="Konfigurere konfidensielle jobber">
      Konfigurere konfidensielle jobber
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_no" title="Skrive ut konfidensielle og andre holdte jobber">
      Skrive ut konfidensielle og andre holdte jobber
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_no" title="Skrive ut en liste med skrifteksempler">
      Skrive ut en liste med skrifteksempler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_no" title="Skrive ut en katalogliste">
      Skrive ut en katalogliste
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_no" title="Sette inn skilleark i utskriftsjobber">
      Sette inn skilleark i utskriftsjobber
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_no" title="Avbryte en utskriftsjobb">
      Avbryte en utskriftsjobb
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_no" title="Justere tonerm&oslash;rkhet">
      Justere tonerm&oslash;rkhet
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_no" title="Skrivermenyer">
     Skrivermenyer
    </a>
   </p>
   <div id="divd0e14542">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_no" title="Menyoversikt">
      Menyoversikt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e14850" title="Enhet">
      Enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e16760" title="Skriv ut">
      Skriv ut
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e18041" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e18318" title="USB-stasjon">
      USB-stasjon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e18582" title="Nettverk/porter">
      Nettverk/porter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e20704" title="Sikkerhet">
      Sikkerhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e21768" title="Nettskytjenester">
      Nettskytjenester
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e21825" title="Rapporter">
      Rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_no" title="Feils&oslash;king">
      <strong>
       Feils&oslash;king
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_no" title="Forms Merge">
      <strong>
       Forms Merge
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_no" title="Skrive ut Menyinnstillinger-siden">
      Skrive ut
      <strong>
       Menyinnstillinger-siden
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_no" title="Etterbehandlingsalternativer for skriveren">
     Etterbehandlingsalternativer for skriveren
    </a>
   </p>
   <div id="divd0e22213">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_no" title="Bruke stifteenheten">
      Bruke stifteenheten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_no" title="Bruke stifte- og hulleenheten">
      Bruke stifte- og hulleenheten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_no" title="Bruke forskj&oslash;vet stabling">
      Bruke forskj&oslash;vet stabling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_no" title="Bruke funksjonen for hefting">
      Bruke funksjonen for hefting
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_no" title="Bruke papirtransporten med alternativet for bretting">
      Bruke papirtransporten med alternativet for bretting
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_no" title="Vedlikeholde skriveren">
     Vedlikeholde skriveren
    </a>
   </p>
   <div id="divd0e22622">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_no" title="Kontrollere status for deler og rekvisita">
      Kontrollere status for deler og rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_no" title="Konfigurere varsler for rekvisita">
      Konfigurere varsler for rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_no" title="Konfigurere e-postvarsler">
      Konfigurere e-postvarsler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_no" title="Generere rapporter og loggf&oslash;ringer">
      Generere rapporter og loggf&oslash;ringer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_no" title="Bestille deler og rekvisita">
      Bestille deler og rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e23221" title="Bytte ut deler og rekvisita">
      Bytte ut deler og rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e23810" title="Rengj&oslash;re skriverdelene">
      Rengj&oslash;re skriverdelene
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e23924" title="Spare energi og papir">
      Spare energi og papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_no" title="Flytte skriveren til et annet sted">
      Flytte skriveren til et annet sted
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_no" title="Feils&oslash;ke et problem">
     Feils&oslash;ke et problem
    </a>
   </p>
   <div id="divd0e24059">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_no" title="Problemer med utskriftskvalitet">
      Problemer med utskriftskvalitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_no" title="Skriverfeilkoder">
      Skriverfeilkoder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e25234" title="Utskriftsproblemer">
      Utskriftsproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_no" title="Skriveren svarer ikke">
      Skriveren svarer ikke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_no" title="Kan ikke lese flash-enhet">
      Kan ikke lese flash-enhet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_no" title="Aktivere USB-porten">
      Aktivere USB-porten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_no" title="Fjerne papirstopp">
      Fjerne papirstopp
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e27215" title="Problemer med nettverkstilkobling">
      Problemer med nettverkstilkobling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e27306" title="Problemer med tilleggsutstyr">
      Problemer med tilleggsutstyr
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e27474" title="Problemer med rekvisita">
      Problemer med rekvisita
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e27622" title="Problemer med papirmating">
      Problemer med papirmating
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e27816" title="Problemer med fargekvaliteten">
      Problemer med fargekvaliteten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_no" title="Slik kontakter du brukerst&oslash;tte">
      Slik kontakter du brukerst&oslash;tte
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_no" title="Resirkuler og kast">
     Resirkuler og kast
    </a>
   </p>
   <div id="divd0e28040">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_no" title="Resirkulering av Lexmark-produkter">
      Resirkulering av Lexmark-produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_no" title="Resirkulering av Lexmark-emballasje">
      Resirkulering av Lexmark-emballasje
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug.html#laser_ug_notices_no" title="Merknader">
     Merknader
    </a>
   </p>
   <div id="divd0e28074">
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e28077" title="Produktinformasjon">
      Produktinformasjon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e28094" title="Versjonsmerknad">
      Versjonsmerknad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#trademarks_no" title="Varemerker">
      Varemerker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#licensing-notices_no" title="Lisensmerknader">
      Lisensmerknader
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#noise-emission-levels_no" title="St&oslash;yniv&aring;er">
      St&oslash;yniv&aring;er
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#weee-directive_no" title="WEEE-direktiv (Waste of Electrical and Electronic Equipment)">
      WEEE-direktiv (Waste of Electrical and Electronic Equipment)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e28192" title="Oppladbart litiumionbatteri">
      Oppladbart litiumionbatteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#eu-battery-directive-2023-1542_no" title="Forskrift (EU) 2023/1542">
      Forskrift (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e28229" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#product-disposal_no" title="Produktkassering">
      Produktkassering
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#returning-lexmark-cartridges-for-reuse-or-recycling_no" title="Returnere Lexmark-kassetter for gjenbruk eller gjenvinning">
      Returnere Lexmark-kassetter for gjenbruk eller gjenvinning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#static-sensitivity-notice_no" title="Varsel om statisk elektrisitet">
      Varsel om statisk elektrisitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#energy-star_no" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#temperature-information_no" title="Temperaturinformasjon">
      Temperaturinformasjon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#laser-notice_no" title="Lasermerknad">
      Lasermerknad
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#power-consumption_no" title="Str&oslash;mforbruk">
      Str&oslash;mforbruk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e28490" title="Juridiske merknader for tr&aring;dl&oslash;se produkter">
      Juridiske merknader for tr&aring;dl&oslash;se produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#modular-component-notice_no" title="Merknad om modul&aelig;re komponenter">
      Merknad om modul&aelig;re komponenter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#exposure-to-radio-frequency-radiation_no" title="Eksponering for str&aring;ling">
      Eksponering for str&aring;ling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#d0e28515" title="Samsvar med EU-direktiver">
      Samsvar med EU-direktiver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#european-community-ec-directives-conformity-class-a_no" title="Samsvar med EU-direktiver">
      Samsvar med EU-direktiver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug.html#radio-interference-notice_no" title="Radiointerferens">
      Radiointerferens
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue